/**
 * Credentials strip.
 * - Mobile: sets the scroll duration from the lane width, so the lane always moves at the same speed (in px per second)
 *   whatever the number of badges.
 * - Tablet and desktop: the badges wrap naturally when the row runs out of room. A group divider that ends up at the
 *   start or end of a row is hidden, so it only shows between two badges on the same row.
 */
if (!window.customElements.get('credentials-strip')) {
  window.customElements.define(
    'credentials-strip',
    class CredentialsStrip extends HTMLElement {
      connectedCallback() {
        this._copy = this.querySelector('.credentials-strip__copy');

        if (!this._copy || !window.ResizeObserver) {
          return;
        }

        this._resizeObserver = new ResizeObserver(() => {
          this._updateDuration();
          this._updateDividers();
        });
        this._resizeObserver.observe(this);
        this._resizeObserver.observe(this._copy);
      }

      disconnectedCallback() {
        this._resizeObserver?.disconnect();
      }

      _updateDuration() {
        const speed = parseFloat(this.getAttribute('speed')) || 40;
        const width = this._copy.getBoundingClientRect().width;

        if (width > 0) {
          this.style.setProperty('--credentials-duration', `${(width / speed).toFixed(2)}s`);
        }
      }

      _updateDividers() {
        this._copy.querySelectorAll('.credentials-strip__divider').forEach((divider) => {
          const before = divider.previousElementSibling?.querySelector('.credentials-strip__badge:last-child');
          const after = divider.nextElementSibling?.querySelector('.credentials-strip__badge');

          if (!before || !after) {
            return;
          }

          const isWrapped = Math.abs(before.getBoundingClientRect().top - after.getBoundingClientRect().top) > 1;
          divider.classList.toggle('is-wrapped', isWrapped);
        });
      }
    }
  );
}
